import moment from "moment";
import couriers from "@/constants/couriers.json";

export function formatTipoParada(tipo) {
  return tipo === "ENTREGA" ? "Entrega" : tipo === "RECOGIDA" ? "Recogida" : "Recogida o entrega";
}

export function clearFiltersQuery(router, route, apply) {
  if (!Object.keys(route.query).length) {
    apply();
    return;
  }
  router.replace({ path: route.path, query: {}, hash: route.hash }, apply);
}

export function getFilterDateRange(value, fallback) {
  if (typeof value === "string") {
    const fecha = moment(value, "YYYY-MM-DD", true);
    if (fecha.isValid()) return [fecha.toDate(), fecha.toDate()];
  }
  if (Array.isArray(value) && value.length === 2 &&
      value.every((date) => date && Number.isFinite(new Date(date).getTime())) &&
      new Date(value[0]).getTime() <= new Date(value[1]).getTime()) {
    return value;
  }
  return fallback;
}

export function downloadFile(response) {
  const blob = response.blob instanceof Blob ? response.blob : new Blob([response.blob]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", response.fileName);
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  }
}

export function formatAddress(address, countries = []) {
  const parts = [];

  // Line 1: Street, Number, Extra
  let streetPart = address.via;
  if (address.numero) {
    streetPart += `, ${address.numero}`;
  }
  if (address.extra) {
    streetPart += ` ${address.extra}`;
  }
  if (streetPart) {
    parts.push(streetPart);
  }

  // Line 2: Postal Code, City
  let cityPart = address.codigoPostal;
  if (address.poblacion) {
    cityPart += ` ${address.poblacion}`;
  }
  if (cityPart) {
    parts.push(cityPart);
  }

  // Line 3: Province, Country
  let provinceCountryPart = address.provincia;
  if (address.pais) {
    const country = countries.find((c) => c.iso2 === address.pais);
    provinceCountryPart += `, ${country ? country.nombre.es : address.pais}`;
  }
  if (provinceCountryPart) {
    parts.push(provinceCountryPart);
  }

  return parts.join(", ");
}

export function checkRangeFechas(value, maxDaysRange) {
  const fechaInicio = new Date(value[0]).getTime();
  const fechaFinal = new Date(value[1]).getTime();
  const diff = fechaFinal - fechaInicio;
  // Días naturales: con un cambio de hora en el rango la diferencia no es un múltiplo exacto de 24 h
  const final = Math.round(diff / (1000 * 60 * 60 * 24));
  if (final > maxDaysRange) {
    return false;
  }
  return true;
}

// Backend timestamps are UTC, including those without an explicit Z suffix.
export function formatUtcDateLocal(fecha, format = "DD/MMM/YYYY HH:mm") {
  if (!fecha) return "";
  const local = moment.utc(fecha).local();
  return local.isValid() ? local.format(format) : "";
}

export function formatTipoEstado(tipo) {
  if (tipo === "ANOMALIA") return "Incidencia";
  if (tipo === "ESTADO") return "Estado";
  return tipo || "";
}

export function formatCourier(courier) {
  const item = couriers.find((item) => item.value === courier);
  return item ? item.name : courier || "-";
}

// A stop's date is a calendar day in UTC; state timestamps use local time.
export function formatUtcDate(fecha) {
  if (!fecha) return "-";
  const date = moment.utc(fecha);
  return date.isValid() ? date.format("DD/MMM/YYYY") : "-";
}


// Same classification as the backend's Paradas views. Partner takes precedence.
export function getVistaParada(parada) {
  if (!parada) return null;
  if (parada.tipo === "RECOGIDA") {
    if (parada.paradaFranquicia === true) return "recogidas_partner";
    if (parada.courier === "OXPERTA") return "recogidas_propias";
    if (parada.courier) return "recogidas_otras_plazas";
  }
  if (parada.tipo === "ENTREGA" && parada.courier === "OXPERTA") return "entregas_propias";
  return null;
}

export function getUrlParada(router, parada, vistasParadas) {
  const vista = getVistaParada(parada);
  const config = Object.values(vistasParadas).find((item) => item.vista === vista);
  const campo = vista === "recogidas_partner" ? "referenciaCourier" : "numero";
  const value = parada && parada[campo];
  const valor = value === null || value === undefined ? "" : String(value).trim();
  if (!config || !valor) return "";
  const query = { [campo]: valor, ignoreSavedFilters: "true" };
  const fecha = parada.fecha && moment.utc(parada.fecha);
  if (fecha && fecha.isValid()) query.fecha = fecha.format("YYYY-MM-DD");
  return router.resolve({ path: config.ruta, query }).href;
}

export function getUrlEnvio(router, identificador, fechaEnvio) {
  if (!identificador) return "";
  const query = { identificadores: identificador, ignoreSavedFilters: "true" };
  const fecha = fechaEnvio && moment.utc(fechaEnvio);
  if (fecha && fecha.isValid()) query.fecha = fecha.format("YYYY-MM-DD");
  return router.resolve({ path: "/franquiciadora/envios", query }).href;
}
